import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { globalStyle, style, styleVariants } from '@vanilla-extract/css';
import {
  sidebarLaptopWidth,
  navbarHeight,
  sidebarTabletWidth,
} from '../../constants/styles-vars';

globalStyle('html', {
  scrollbarGutter: 'stable',
});

export const rootVariants = styleVariants({
  public: {
    ...responsiveStyle({
      mobile: {
        gridTemplateColumns: '1fr',
        gridTemplateRows: `1fr`,
        gridTemplateAreas: `
          "main"
        `,
      },
      tablet: {
        gridTemplateColumns: `1fr`,
        gridTemplateRows: `1fr`,
        gridTemplateAreas: '"main"',
      },
      laptop: {
        gridTemplateColumns: `${sidebarLaptopWidth} 1fr`,
        gridTemplateAreas: '"sidebar main"',
      },
    }),
  },
  protected: {
    ...responsiveStyle({
      mobile: {
        gridTemplateColumns: '1fr',
        gridTemplateRows: `1fr ${navbarHeight}`,
        gridTemplateAreas: `
          "main"
          "sidebar"
        `,
      },
      tablet: {
        gridTemplateColumns: `${sidebarTabletWidth} 1fr`,
        gridTemplateRows: `1fr`,
        gridTemplateAreas: '"sidebar main"',
      },
      laptop: {
        gridTemplateColumns: `${sidebarLaptopWidth} 1fr`,
      },
    }),
  },
});

export const rootWithSidebarCollapsed = style({
  selectors: {
    '&:is(&)': {
      gridTemplateColumns: `${sidebarTabletWidth} 1fr`,
    },
  },
});

export const root = style({
  isolation: 'isolate',
  display: 'grid',
  height: '100%',
});
